import Header from 'organisms/header';
import React from 'react';
import './pageLayout.css';

/**
 * Layout for a standalone page with a header
 */
const PageLayout = ({
  children = [],
}: {
  children: JSX.Element[] | JSX.Element;
}) => (
  <div className="pageContainer">
    <Header hideHamburgerMenu />
    <main className="pageContentWrapper">{children}</main>
  </div>
);

export default PageLayout;
